import type {RelationshipConstraint} from '@packages/systems/constraints-types';

export const SHARED_FORM_WRAPPER_CONSTRAINTS_DESCENDANTS: RelationshipConstraint[] =
  [
    {is: 'CommerceAddToCartWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutFormContainer', rule: 'Forbid'},
    {is: 'CommercePaypalCheckoutFormContainer', rule: 'Forbid'},
    {is: 'FormWrapper', rule: 'Forbid'},
    {is: 'SearchForm', rule: 'Forbid'},
  ];

export const SHARED_FORM_CONSTRAINTS_DESCENDANTS: RelationshipConstraint[] = [
  {is: 'CommerceAddToCartForm', rule: 'Forbid'},
  {is: 'CommerceAddToCartWrapper', rule: 'Forbid'},
  {is: 'CommerceCheckoutFormContainer', rule: 'Forbid'},
  {is: 'CommercePaypalCheckoutFormContainer', rule: 'Forbid'},
  {is: 'FormForm', rule: 'Forbid'},
  {is: 'FormWrapper', rule: 'Forbid'},
  {is: 'SearchForm', rule: 'Forbid'},
];

export const SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS: RelationshipConstraint[] =
  [
    {is: 'CommerceCheckoutCustomerInfoWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutPaymentInfoWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutPlaceOrderButton', rule: 'Forbid'},
    {is: 'CommerceCheckoutShippingAddressWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutBillingAddressWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutShippingMethodsWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutErrorState', rule: 'Forbid'},
    {is: 'CommerceCheckoutShippingSummaryWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutCustomerInfoSummaryWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutOrderSummaryWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutPaymentSummaryWrapper', rule: 'Forbid'},
    {is: 'CommerceCheckoutOrderItemsWrapper', rule: 'Forbid'},
    {is: 'CommerceDownloadsWrapper', rule: 'Forbid'},
  ];

export const CommerceOrderWrapperConstraint = {
  is: [
    'CommerceCheckoutFormContainer',
    'CommercePaypalCheckoutFormContainer',
    'CommerceOrderConfirmationContainer',
  ],
  name: 'Order Confirmation or Checkout Form',
  rule: 'ExactlyOne',
} as const;

export const CommerceCheckoutFormConstraint = {
  is: ['CommerceCheckoutFormContainer', 'CommercePaypalCheckoutFormContainer'],
  name: 'Checkout Form',
  rule: 'ExactlyOne',
} as const;

export const CommerceCartOrCheckoutFormConstraint = {
  is: ['CommerceCartForm', 'CommerceCheckoutFormContainer'],
  name: 'Cart or Checkout Form',
  rule: 'ExactlyOne',
} as const;
